"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divider = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _responsiveProps = require("../../internal/responsiveProps");
var _Wrapper = _interopRequireDefault(require("../Wrapper"));
var _tokens = require("../../tokens");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const StyledDivider = (0, _styledComponents.default)(props => /*#__PURE__*/_react.default.createElement(_Wrapper.default, _extends({
  omitProps: {
    keys: ['size', 'color'],
    responsiveKeys: ['vertical']
  },
  containerVerticalPadding: 0
}, props))).withConfig({
  displayName: "StyledDivider",
  componentId: "sc-rdw6kz-0"
})(["background:", ";background-clip:content-box;width:100%;height:", ";", ""], _ref => {
  let {
    color
  } = _ref;
  return color;
}, _ref2 => {
  let {
    size
  } = _ref2;
  return size;
}, props => (0, _responsiveProps.responsiveCssProps)({
  props: props,
  propName: 'vertical',
  output: v => v && `
        height: 100%;
        width: ${props.size};
      `
}));

/**
## Usage

```jsx
import { Divider } from '@farewill/ui'
```

## Notes

`<Divider>` extends from `<Wrapper>` so can use any of `<Wrapper>`’s styling functionality, notably `container`. Setting `container` does not add the usual top and bottom padding, but vertical spacing can be controlled using `margin`.

If `maxWidth` is set without `container`, the `margin` will also have to be set to `[0, 'auto']` or similar to avoid left-alignment.

Vertical `<Divider>`s can be used inside the `<Grid>` with the `dividerAtColumn` prop.
 */
const Divider = props => /*#__PURE__*/_react.default.createElement(StyledDivider, props);
exports.Divider = Divider;
Divider.defaultProps = {
  size: '1px',
  color: _tokens.COLOR.GREY.LIGHT
};